import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      flex: "0 0 342px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(2),
      paddingTop: theme.spacing(2),
      backgroundColor: theme.palette.common.white,
      marginRight: theme.spacing(1),
    },
  })
);
